import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '../../../../services/header/header.service';
import { ExportService } from '../../shared/export.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../../../../services/commande-client/data.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-devis',
    templateUrl: './devis.component.html',
    styleUrls: ['./devis.component.scss']
})
export class DevisComponent implements OnInit {
    currentStatus: string = 'tous';
    statuses: string[] = ['tous', 'brouillon', 'cree', 'annule', 'negociation', 'accepte'];

    statusCounts$: Observable<Record<string, number>> = this.dataService.quoteTableData$.pipe(
        startWith(this.dataService.getQuoteTableData() || []),
        map((data: any[]) => this.computeStatusCountsFromApiOrData(Array.isArray(data) ? data : []))
    );

    currentUser: any = null;
    userId: number | null = null;
    stationId: number | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService,
        private headerService: HeaderService,
        private exportService: ExportService,
        private toastr: ToastrService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.userId = this.currentUser?.id || null;
        this.stationId = this.currentUser?.stations?.[0]?.id || null;
    }

    ngOnInit(): void {
        this.headerService.setConfig({
            title: 'Devis',
            buttons: [
                {
                    label: 'Exporter',
                    type: 'dropdown',
                    dropdownItems: [
                        {
                            label: 'PDF',
                            action: () => this.exportService.triggerPDF(),
                            icon: '../../../assets/images/logo/pdf_logo.png'
                        },
                        {
                            label: 'CSV',
                            action: () => this.exportToCSV(),
                            icon: '../../../assets/images/logo/csv_logo.png'
                        }
                    ]
                }
            ]
        });
        // Comme commande-client : ne pas déclencher de chargement ici, seulement mettre à jour l'onglet actif.
        // Le chargement est fait uniquement au clic (filterByStatus), évitant double requête et mauvais compteur.
        this.route.firstChild?.url.subscribe(segments => {
            const path = segments.length > 0 ? segments[0].path : 'tous';
            this.currentStatus = path.toLowerCase();
        });
    }

    filterByStatus(status: string) {
        this.currentStatus = status.toLowerCase();
        const mappedStatus = this.mapPathToStatus(status);

        // ON UTILISE LA MÉTHODE QUI MARCHE DÉJÀ !
        this.dataService.loadByTypeAndStatus('devis', mappedStatus);

        this.router.navigate([`/vente/devis/${status.toLowerCase()}`]);
    }

    /** Utilise total_items de l'API quand disponible, sinon compte depuis les données chargées. */
    private computeStatusCountsFromApiOrData(data: any[]): Record<string, number> {
        const statusKeys = ['Tous', 'Brouillon', 'Crée', 'Annulé', 'Négociation', 'Accepté'];
        const counts: Record<string, number> = {};
        statusKeys.forEach(s => {
            const fromApi = this.dataService.getQuoteTotalItems(s);
            if (fromApi > 0) {
                counts[s] = fromApi;
            } else {
                counts[s] = s === 'Tous' ? data.length : data.filter((i: any) => (i?.status ?? '') === s).length;
            }
        });
        return counts;
    }

    private mapPathToStatus(path: string): string {
        const statusMap: { [key: string]: string } = {
            tous: 'Tous',
            brouillon: 'Brouillon',
            cree: 'Crée',
            annule: 'Annulé',
            negociation: 'Négociation',
            accepte: 'Accepté'
        };
        return statusMap[path.toLowerCase()] || 'Tous';
    }

    private exportToCSV(): void {
        const data = this.dataService.getQuoteTableData();
        const headers = ['Référence', 'Client', 'Date', 'Revenu', 'Matricule', 'Statut'];
        const rows = data.map(item => [
            `"${(item.reference || '').replace(/"/g, '""')}"`,
            `"${(item.clientName || '').replace(/"/g, '""')}"`,
            `"${(item.date || '').replace(/"/g, '""')}"`,
            `"${(item.revenue || '').replace(/"/g, '""')}"`,
            `"${(item.matricule || '').replace(/"/g, '""')}"`,
            `"${(item.status || '').replace(/"/g, '""')}"`
        ]);
        const csvContent = headers.join(',') + '\n' + rows.map(row => row.join(',')).join('\n');
        this.exportService.downloadCSV(csvContent, 'devis.csv');
    }
}
